import { Fragment, useState, useRef, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Row, Col, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPlus, faCircleInfo, faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { languageOptions } from './Constants'; 
import CKEditorComponent from '../../Common/CKEditor/CKEditorComponent'; 
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import Icon from "../../../src/Components/Inbox/components/Icon";
import CratioFileUploader from '../Common/CratioFileUploader';
import { getWABodyVariables, randomNumber, uploadFileIntoS3, showToast, decodeString, parseJSON, getWAComponents, replaceStringTohtml, normalizeTemplateVariables } from '../../Common/Appcommon';
import cx from "classnames";
import { Reorder } from "framer-motion";
import './CarouselModal.css';
import VariableRow from './VariableRow';
import requestApiService from '../../services/requestApi.service';
import CarouselTemplatePreview from '../WhatsappComponents/CarouselTemplatePreview';

const CarouselModal = (props) => {
    const { toggleCarouselModal, isOpen, template } = props;
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();
    const [formData, setFormData] = useState({ 
        category: 'MARKETING',
        cards: [{ mediaHeaderFormat: 'IMAGE', buttons: [{ id: Date.now(), type: 'quick_reply', text: '' }] }] 
    });
    const [showEmojis, setShowEmojis] = useState(false);
    const [emojiPos, setEmojiPos] = useState({ top: 0, left: 0 });
    const emojiRef = useRef(null);
    const [varaction, setVaraction] = useState("");
    const [variableCount, setVariableCount] = useState("");
    const [apiError, setApiError] = useState("");
    const [invalidCardIndices, setInvalidCardIndices] = useState([]);
    const [uploadingCardIndices, setUploadingCardIndices] = useState([]);
    const [buttonErrors, setButtonErrors] = useState({});
    const [isCreating, setIsCreating] = useState(false);
    const cardRefs = useRef([]);
    const panelRef = useRef(null);

    useEffect(() => {
        if (template && template.Name) {
            let data = {
                name: template.Name,
                template_id: template.Template_ID,
                language: template.Language,
                category: template.Category,
                cards: [{ mediaHeaderFormat: 'IMAGE', buttons: [] }]
            };
            
            let langObj = languageOptions.find(opt => opt.value === template.Language) || null;
            if (langObj) {
                setValue("language", langObj);
                data.language = langObj;
            }
            setValue("name", template.Name);

            if (template.Components) {
                let compArr = parseJSON(decodeString(template.Components));
                let waComps = getWAComponents(compArr);
                
                if (waComps['BODY']) {
                    let text = waComps['BODY']['text'];
                    let htmlText = replaceStringTohtml(text);
                    data.message = htmlText;
                    setValue("message", htmlText);
                    
                    let bodyVariables = getWABodyVariables(text);
                    if (waComps['BODY']['example'] && waComps['BODY']['example']['body_text'] && waComps['BODY']['example']['body_text'][0]) {
                        let examples = waComps['BODY']['example']['body_text'][0];
                        bodyVariables.forEach((v, index) => {
                            let fallback = examples[index] || "";
                            data[`variable_${v}_fallback`] = fallback;
                            setValue(`variable_${v}_fallback`, fallback);
                        });
                    }
                }
                
                if (waComps['CAROUSEL'] && waComps['CAROUSEL']['cards']) {
                    let cards = waComps['CAROUSEL']['cards'].map((c, cIdx) => {
                        let cardData = {
                            mediaHeaderFormat: 'IMAGE',
                            body: '',
                            buttons: []
                        };
                        let cComps = {};
                        if(c.components) {
                            c.components.forEach(cmp => {
                                cComps[cmp.type] = cmp;
                            });
                        }
                        
                        if (cComps['HEADER']) {
                            cardData.mediaHeaderFormat = cComps['HEADER']['format'];
                            if (cComps['HEADER']['example'] && cComps['HEADER']['example']['header_handle'] && cComps['HEADER']['example']['header_handle'].length > 0) {
                                cardData.media_handle = cComps['HEADER']['example']['header_handle'][0];
                                cardData.is_original_handle = true;
                            }
                        }
                        if (cComps['BODY']) {
                            cardData.body = cComps['BODY']['text'];
                        }
                        if (cComps['BUTTONS'] && cComps['BUTTONS']['buttons']) {
                            cardData.buttons = cComps['BUTTONS']['buttons'].map((btn, idx) => {
                                let typeStr = btn.type.toLowerCase();
                                let btnType = typeStr === 'phone_number' ? 'phone_number' : (typeStr === 'url' ? 'url' : 'quick_reply');
                                let textVal = btn.text || '';
                                let linkVal = typeStr === 'url' ? btn.url : (typeStr === 'phone_number' ? btn.phone_number : '');
                                
                                setValue(`cards[${cIdx}].buttons[${idx}].text`, textVal);
                                if (linkVal) {
                                    setValue(`cards[${cIdx}].buttons[${idx}].value`, linkVal);
                                }
                                
                                return {
                                    id: Date.now() + Math.random() + idx,
                                    type: btnType,
                                    text: textVal,
                                    value: linkVal
                                };
                            });
                        }
                        return cardData;
                    });
                    if (cards.length > 0) {
                        data.cards = cards;
                    }
                }
            }
            setFormData(prev => ({ ...prev, ...data }));
            setIsCreating(false);
        }
    }, [template, setValue]);


    const toggleEmoji = () => {
        if (!showEmojis && emojiRef.current) {
            const rect = emojiRef.current.getBoundingClientRect();
            // Position above the icon (approx 435px height for picker)
            // Or just centered? Screenshot showed it aligned left of icon and above.
            // Let's try aligning bottom-left of picker to top-left of icon
            // But we need to ensure it doesn't go off screen.
            // Safe bet: top = rect.top - 440, left = rect.left
            const top = rect.top - 440 > 0 ? rect.top - 440 : 10; 
            setEmojiPos({ top: top, left: rect.left });
        }
        setShowEmojis(!showEmojis);
    };

    const formatMessageBody = (html) => {
        if (!html) return '';
        let text = html;
        text = text.replace(/<strong\b[^>]*>(.*?)<\/strong>/gi, '*$1*')
                   .replace(/<b\b[^>]*>(.*?)<\/b>/gi, '*$1*')
                   .replace(/<em\b[^>]*>(.*?)<\/em>/gi, '_$1_')
                   .replace(/<i\b[^>]*>(.*?)<\/i>/gi, '_$1_')
                   .replace(/<s\b[^>]*>(.*?)<\/s>/gi, '~$1~')
                   .replace(/<strike\b[^>]*>(.*?)<\/strike>/gi, '~$1~')
                   .replace(/<del\b[^>]*>(.*?)<\/del>/gi, '~$1~')
                   .replace(/<code\b[^>]*>(.*?)<\/code>/gi, '```$1```');
        
        text = text.replace(/<\/p>/gi, '\n').replace(/<\/div>/gi, '\n').replace(/<br\s*\/?>/gi, '\n');
        text = text.replace(/<[^>]+>/g, ''); 
        text = text.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        return text.trim();
    };

    const onSubmit = async (data) => {
        if (template && template.Name) {
            setApiError("Carousel templates cannot be updated.");
            return;
        }
        setApiError("");
        setInvalidCardIndices([]);
        setIsCreating(true);

        let components = [];
        let bodyText = formatMessageBody(formData.message || '');
        let originalVariables = [...new Set(getWABodyVariables(bodyText))].map(v => parseInt(v, 10)).filter(n => !isNaN(n)).sort((a, b) => a - b);
        let normalizedBodyText = normalizeTemplateVariables(bodyText);
        
        let bodyComponent = {
            type: "BODY",
            text: normalizedBodyText
        };

        if (originalVariables && originalVariables.length > 0) {
            let examples = [];
            originalVariables.forEach(v => {
                let val = formData[`variable_${v}_fallback`];
                examples.push(val || "Sample");
            });
            bodyComponent.example = {
                body_text: [examples]
            };
        }
        components.push(bodyComponent);

        // Validate Carousel Cards
        let newInvalidIndices = [];
        let newButtonErrors = {};

        for(let i = 0; i < formData.cards.length; i++) {
            let card = formData.cards[i];
            let isMediaInvalid = false;

            // Validate Media
            let handle = card.media_handle || card.h || null;
            if(!handle || card.is_original_handle) {
                isMediaInvalid = true;
            }
            
            // Validate Buttons
            if(card.buttons && card.buttons.length > 0) {
                 for(let j = 0; j < card.buttons.length; j++) {
                     let btn = card.buttons[j];
                     if(!btn.text || btn.text.trim() === '') {
                        newButtonErrors[`${i}_${j}_text`] = "Button text is required";
                     }
                     if(btn.type === 'url' && (!btn.value || btn.value.trim() === '')) {
                        newButtonErrors[`${i}_${j}_value`] = "Website URL is required";
                     }
                     if(btn.type === 'phone_number' && (!btn.value || btn.value.trim() === '')) {
                        newButtonErrors[`${i}_${j}_value`] = "Phone number is required";
                     }
                 }
            }

            if(isMediaInvalid) {
                newInvalidIndices.push(i);
            }
        }

        if (newInvalidIndices.length > 0 || Object.keys(newButtonErrors).length > 0) {
            setInvalidCardIndices(newInvalidIndices);
            setButtonErrors(newButtonErrors);
            setIsCreating(false);

            // Handle parent component coordinate scrolling via references
            setTimeout(() => {
                let errorIdx = -1;
                if (newInvalidIndices.length > 0) {
                    errorIdx = newInvalidIndices[0];
                } else if (Object.keys(newButtonErrors).length > 0) {
                    errorIdx = parseInt(Object.keys(newButtonErrors)[0].split('_')[0], 10);
                }

                if (errorIdx !== -1 && cardRefs.current[errorIdx] && panelRef.current) {
                    const cardElement = cardRefs.current[errorIdx];
                    panelRef.current.scrollTo({
                        top: cardElement.offsetTop - 20,
                        behavior: 'smooth'
                    });
                }
            }, 100);

            return;
        }

        let carouselCards = formData.cards.map(card => {
            let cardComponents = [];
            if(card.mediaHeaderFormat) {
                let handle = card.media_handle || card.h || null;
                let header = {
                    type: "HEADER",
                    format: card.mediaHeaderFormat
                };
                if(handle) {
                    header.example = { header_handle: [handle] };
                }
                cardComponents.push(header);
            }
            
            cardComponents.push({
                type: "BODY",
                text: card.body || ' '
            });

            if(card.buttons && card.buttons.length > 0){
                 let buttons = card.buttons.map(btn => {
                     let btnObj = {
                         type: btn.type === 'quick_reply' ? 'QUICK_REPLY' : (btn.type === 'phone_number' ? 'PHONE_NUMBER' : 'URL'),
                         text: btn.text
                     };
                     if(btn.type === 'url') btnObj.url = btn.value;
                     if(btn.type === 'phone_number') btnObj.phone_number = btn.value;
                     return btnObj;
                 });
                 cardComponents.push({
                     type: "BUTTONS",
                     buttons: buttons
                 });
            }
            return { components: cardComponents };
        });

        components.push({
            type: "CAROUSEL",
            cards: carouselCards
        });

        let payload = {
            name: data.name,
            template_id: template.Template_ID,
            language: data.language.value,
            category: formData.category,
            components: components
        };

        console.log("Submitting Carousel Template:", payload);
        
        // TODO: Replace with actual API call once OPERATION is confirmed
        let params = { 
            "ENTITY": "WHATSAPPPROCESS", 
            "OPERATION": "saveCarouselTemplate", 
            "FORMINPUT": payload, 
        };
        try {
            let res = await requestApiService.processServerRequest(params, "WebV2", "post");
            
            if(res.issuccess && res.data === "Success"){
                showToast(template && template.Name ? "Template Updated Successfully!" : "Template Created Successfully!", "top-right", "success");
                toggleCarouselModal();
            }else{
                const actionWord = template && template.Name ? "update" : "create";
                console.error(`Failed to ${actionWord} template: ` + res);
                let errorMsg = res.errormsg || `Failed to ${actionWord} template`;
                if (typeof res.data === 'string' && res.data !== "") {
                     errorMsg = res.data;
                }
                setApiError(errorMsg);
            }
        } catch (error) {
            console.error("API Error: ", error);
            setApiError("An unexpected error occurred.");
        } finally {
            setIsCreating(false);
        }
    };

    const handleInputChange = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
        setValue(name, value);
    }

    const formatTemplateName = (value) => {
        return value.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    };

    const addEmoji = (emojiObject) => {
        if (emojiObject.native) {
            setVaraction("insertEmoji");
            setVariableCount(emojiObject.native + "#$#" + randomNumber());
        }
    };

    const addVariable = () => {
        let count = 1;
        let variables = [];
        let message = formData.message || '';
        if (message !== '' && message !== null) {
            variables = getWABodyVariables(message);
            if (variables.length > 0) {
                count = Math.max(...variables.map(Number)) + 1;
            }
        }
        setVaraction("insertText");
        setVariableCount(`{{${count}}}#$#${randomNumber()}`);
    }

    const onCardFileUpload = async (e, index) => {
        setUploadingCardIndices(prev => [...prev, index]);
        try {
            // Pass the specific card object as 'formData' context for the uploader utility
            // assuming it reads mediaHeaderFormat from it.
            const card = formData.cards[index]; 
            let { formInputData } = await uploadFileIntoS3(e, card, true);
            
            const newCards = [...(formData.cards || [])];
            newCards[index] = { ...newCards[index], ...formInputData, is_original_handle: false };
            handleInputChange('cards', newCards);
    
            if (invalidCardIndices.includes(index)) {
                setInvalidCardIndices(prev => prev.filter(i => i !== index));
            }
        } catch (error) {
            console.error("File upload failed", error);
            // Optionally setApiError or showToast here if upload fails
        } finally {
            setUploadingCardIndices(prev => prev.filter(i => i !== index));
        }
    }

    const buttonTypeOptions = [
        { label: 'Quick Reply', value: 'quick_reply' },
        { label: 'URL', value: 'url' },
        { label: 'Phone Number', value: 'phone_number' }
    ];

    const handleGlobalButtonAdd = () => {
        const newCards = [...(formData.cards || [])];
        const newButton = { id: Date.now(), type: 'quick_reply', text: '' };
        
        // Add to all cards
        newCards.forEach(card => {
            if (!card.buttons) card.buttons = [];
            if (card.buttons.length < 2) {
                card.buttons.push({...newButton});
            }
        });
        
        handleInputChange('cards', newCards);
    }

    const handleGlobalReorder = (newButtons) => {
        const newCards = [...(formData.cards || [])];
        const newOrderIds = newButtons.map(b => b.id);
        
        newCards.forEach(card => {
            if (card.buttons) {
                card.buttons.sort((a, b) => newOrderIds.indexOf(a.id) - newOrderIds.indexOf(b.id));
            }
        });

        setButtonErrors({});
        handleInputChange('cards', newCards);
    };
    const handleGlobalButtonRemove = (btnIndex) => {
        const currentButtons = formData.cards[0]?.buttons || [];
        if (currentButtons.length <= 1) return;

        const newCards = [...(formData.cards || [])];
        
        // Remove from all cards
        newCards.forEach(card => {
            if (card.buttons && card.buttons.length > btnIndex) {
                card.buttons = card.buttons.filter((_, i) => i !== btnIndex);
            }
        });
        
        handleInputChange('cards', newCards);
    }

    const handleGlobalButtonTypeChange = (btnIndex, type) => {
        const newCards = [...(formData.cards || [])];
        
        // Update type for all cards at this index
        newCards.forEach(card => {
            if (card.buttons && card.buttons[btnIndex]) {
                const button = { ...card.buttons[btnIndex] };
                button.type = type;
                button.value = ''; // Reset value on type change
                card.buttons[btnIndex] = button;
            }
        });
         
        handleInputChange('cards', newCards);
    }

    const handleButtonChange = (cardIndex, btnIndex, field, value) => {
        const newCards = [...(formData.cards || [])];
        const currentButtons = [...(newCards[cardIndex].buttons || [])];
        const button = { ...currentButtons[btnIndex] };
        button[field] = value;
        // Type change handled globally now
        currentButtons[btnIndex] = button;
        newCards[cardIndex].buttons = currentButtons;
        handleInputChange('cards', newCards);

        // Clear error if exists
        const errorKey = `${cardIndex}_${btnIndex}_${field === 'text' ? 'text' : 'value'}`;
        if (buttonErrors[errorKey]) {
            const newErrors = { ...buttonErrors };
            delete newErrors[errorKey];
            setButtonErrors(newErrors);
            
            // Optional: If no more errors for this card (media + buttons), remove from invalidCardIndices
            // This requires more complex check. For now, just clearing error message is fine.
        }
    }

    const handleCardChange = (index, field, value) => {
        const newCards = [...(formData.cards || [])];
        newCards[index] = { ...newCards[index], [field]: value };
        handleInputChange('cards', newCards);
    }
    


    const handleAddCard = () => {
        const currentCards = formData.cards || [];
        if (currentCards.length >= 10) return;

        let newButtons = [{ id: Date.now(), type: 'quick_reply', text: '' }];
        
        // Inherit button structure from the first card (Global Configuration)
        if (currentCards.length > 0 && currentCards[0].buttons) {
             newButtons = currentCards[0].buttons.map((btn, idx) => ({
                 id: Date.now() + idx,
                 type: btn.type,
                 text: '',
                 value: ''
             }));
        }

        handleInputChange('cards', [...currentCards, { mediaHeaderFormat: 'IMAGE', body: '', buttons: newButtons }]);
    }

    const handleRemoveCard = (index) => {
        const currentCards = formData.cards || [];
        if (currentCards.length <= 1) return; // Maintain at least one card
        const newCards = currentCards.filter((_, i) => i !== index);
        handleInputChange('cards', newCards);
    }

    const variables = getWABodyVariables(formData.message || '').sort((a, b) => a - b);

    return (
        <Fragment>
            <Modal isOpen={isOpen} className="media-manager-dialog le-modal-lg" scrollable={true}>
                <ModalHeader toggle={toggleCarouselModal}>
                    {template && template.Name ? "Edit Carousel Template" : "Create Carousel Templates"}
                </ModalHeader>
                <ModalBody>
                    {apiError && (
                        <div className="alert alert-danger mb-3 d-flex align-items-center" role="alert">
                            <FontAwesomeIcon icon={faCircleInfo} className="mr-2" style={{ marginRight: '8px' }} />
                            <div>{apiError}</div>
                        </div>
                    )}
                    <Row className="h-100">
                        <Col md={7} className="h-100 p-0 create-temp-config">
                            <div className="newcampaign-panel" ref={panelRef}>
                                <Form className="vertical-timeline-without-image">
                                    <div className="automation-section row">
                                        <div className="group-header group-header-flex">
                                            <div className="automation-stepnumber">1</div>
                                            <span>Template Details</span>
                                        </div>
                                        <div className="margin-left-3 col-md-11 mt-1">
                                            <Row>
                                                <Col md={8}>
                                                    <FormGroup>
                                                        <Label className="automation-lbl" htmlFor="template_name" id="lbl_template_name" name="lbl_template_name">Template Name <span className="text-danger">*</span></Label>
                                                        <div style={{ position: 'relative' }}>
                                                            <Controller
                                                                name="name"
                                                                control={control}
                                                                rules={{ required: "Template Name is required" }}
                                                                render={({ field: { ref, ...field } }) => (
                                                                    <Input 
                                                                        {...field} 
                                                                        innerRef={ref}
                                                                        id="template_name"
                                                                        placeholder="Enter template name" 
                                                                        maxLength={512}
                                                                        readOnly={!!(template && template.Name)}
                                                                        invalid={!!errors.name} 
                                                                        onChange={(e) => {
                                                                            const formattedValue = formatTemplateName(e.target.value);
                                                                            field.onChange(formattedValue);
                                                                            handleInputChange("name", formattedValue);
                                                                        }}
                                                                        style={{ paddingRight: '70px' }}
                                                                    />
                                                                )}
                                                            />
                                                            {
                                                                !errors.name && (
                                                                    <span 
                                                                        className="text-secondary" 
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '10px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            fontSize: '12px',
                                                                            pointerEvents: 'none'
                                                                        }}
                                                                    >
                                                                        {(formData.name || '').length}/512
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                        {errors.name && <span className="text-danger note-text">{errors.name.message}</span>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label className="automation-lbl" htmlFor="template_language" id="lbl_template_language" name="lbl_template_language">Language <span className="text-danger">*</span></Label>
                                                        <Controller
                                                            name="language"
                                                            control={control}
                                                            rules={{ required: "Language is required" }}
                                                            render={({ field: { ref, ...field } }) => (
                                                                <Select
                                                                    {...field}
                                                                    ref={ref}
                                                                    inputId="template_language"
                                                                    options={languageOptions}
                                                                    placeholder="Select..."
                                                                    classNamePrefix="le-select"
                                                                    onChange={(e) => {
                                                                        field.onChange(e);
                                                                        setFormData(prev => ({ ...prev, language: e.value }));
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        {errors.language && <span className="text-danger note-text">{errors.language.message}</span>}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="automation-section row mt-2">
                                        <div className="group-header group-header-flex">
                                            <div className="automation-stepnumber">2</div>
                                            <span>Body Content</span>
                                        </div>
                                        <div className="margin-left-3 col-md-11 mt-1">
                                            <FormGroup>
                                                <Label className="automation-lbl" htmlFor="template_message" id="lbl_template_message" name="lbl_template_message">Message <span className="text-danger">*</span></Label>
                                                <Controller
                                                    name="message"
                                                    control={control}
                                                    rules={{ 
                                                        required: "Message is required",
                                                        validate: (value) => {
                                                            const message = value || '';
                                                            const plainText = message.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
                                                            const variableList = getWABodyVariables(message);
                                                            const limit = 1024 + (variableList.length * 4);
                                                            if (plainText.length > limit) {
                                                                return `Message content exceeds limit (${limit} characters)`;
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    defaultValue={formData.message || ''}
                                                    render={({ field }) => (
                                                        <CKEditorComponent
                                                            ref={field.ref}
                                                            content={field.value}
                                                            onEditorChange={(data) => {
                                                                field.onChange(data);
                                                                handleInputChange("message", data);
                                                            }}
                                                            isMentionsNeeded={false}
                                                            showToolbar={true}
                                                            type={true}
                                                            addVariable={variableCount}
                                                            action={varaction}
                                                        />
                                                    )}
                                                />
                                                <div className="d-flex justify-content-between align-items-start mt-1">
                                                    <div>
                                                        {errors.message && <span className="text-danger note-text">{errors.message.message}</span>}
                                                    </div>
                                                    <div className="editior-word-counter text-end">
                                                        {(() => {
                                                            const message = formData.message || '';
                                                            const plainText = message.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
                                                            const currentLength = plainText.length;
                                                            const variableList = getWABodyVariables(message);
                                                            const limit = 1024 + (variableList.length * 4); // Logic from existing code
                                                            const isExceeded = currentLength > limit;

                                                            return (
                                                                <span className={isExceeded ? "text-danger" : ""}>
                                                                    {currentLength} / {limit}
                                                                </span>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className={`reply-input-beautifiers justify-content-end`}>
                                                    <div className={`reply-input-variable`} ref={emojiRef}>
                                                        <Icon id="smiley" color={"#919191"} onClick={toggleEmoji} />
                                                        <div className={`quickreply-emoji-wrapper`}>
                                                            <div className={cx(`wp-emoji-picker`, {
                                                                "hide": !showEmojis,
                                                            })} style={{
                                                                position: 'fixed',
                                                                top: emojiPos.top,
                                                                left: emojiPos.left,
                                                                bottom: 'auto',
                                                                height: 'auto',
                                                                zIndex: 9999,
                                                                right: 'auto'
                                                            }}>
                                                                {
                                                                    showEmojis &&
                                                                    <Picker
                                                                        data={data}
                                                                        onEmojiSelect={addEmoji}
                                                                        emojiButtonSize={36}
                                                                        emojiSize={20}
                                                                        previewPosition={`none`}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`reply-input-variable`} onClick={addVariable}>
                                                        <FontAwesomeIcon icon={faPlus} className="mr-1" />
                                                        <span className={`reply-input-variable-text cursor-pointer`}>Add variable</span>
                                                    </div>
                                                </div>
                                            </FormGroup>
                                            
                                            {/* Variable Mapping List */}
                                            {variables.length > 0 && (
                                                <div className="mt-3">
                                                    {variables.map((variable) => (
                                                        <VariableRow 
                                                            key={variable}
                                                            variable={variable}
                                                            control={control}
                                                            errors={errors}
                                                            handleInputChange={handleInputChange}
                                                            formData={formData}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            

                                        </div>
                                    </div>
                                            <div className="automation-section row mt-2">
                                                <div className="group-header group-header-flex">
                                                    <div className="automation-stepnumber">3</div>
                                                    <span>Button Configuration</span>
                                                </div>
                                                <div className="margin-left-3 col-md-11 mt-2">
                                                     <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <Label className='group-header-lbl fw-bold mb-0'>Button Type</Label>
                                                        {(!formData.cards[0]?.buttons || formData.cards[0].buttons.length < 2) && (
                                                            <Button color="link" className="p-0 text-decoration-none text-theme-color" onClick={handleGlobalButtonAdd}>
                                                                <FontAwesomeIcon icon={faPlus} className="mr-1" /> Add Button
                                                            </Button>
                                                        )}
                                                    </div>
                                                    <Reorder.Group axis="y" values={formData.cards[0]?.buttons || []} onReorder={handleGlobalReorder} className="list-unstyled">
                                                        {(formData.cards[0]?.buttons || []).map((btn, btnIndex) => (
                                                            <Reorder.Item key={btn.id} value={btn} className="mb-2">
                                                                <div 
                                                                    className="d-flex align-items-center gap-2 bg-white p-2 border rounded"
                                                                >
                                                                    <div className="mt-1 text-secondary cursor-grab me-2">
                                                                        <FontAwesomeIcon icon={faGripVertical} />
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <Select
                                                                            options={buttonTypeOptions}
                                                                            placeholder="Select Type"
                                                                            classNamePrefix="le-select"
                                                                            value={buttonTypeOptions.find(opt => opt.value === btn.type)}
                                                                            onChange={(e) => handleGlobalButtonTypeChange(btnIndex, e.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="mt-1">
                                                                         {(formData.cards[0]?.buttons?.length > 1) && (
                                                                             <FontAwesomeIcon 
                                                                                 icon={faXmark} 
                                                                                 className="cursor-pointer text-secondary"
                                                                                 onClick={() => handleGlobalButtonRemove(btnIndex)}
                                                                                 title="Remove Button"
                                                                             />
                                                                         )}
                                                                    </div>
                                                                </div>
                                                            </Reorder.Item>
                                                        ))}
                                                    </Reorder.Group>
                                                </div>
                                            </div>

                                            <div className="automation-section row mt-2">
                                                <div className="group-header group-header-flex">
                                                    <div className="automation-stepnumber">4</div>
                                                    <span>Carousel Cards</span>
                                                </div>
                                                <div className="margin-left-3 col-md-11 mt-2">
                                                    {(formData.cards || []).map((card, cardIndex) => (
                                                <div 
                                                    key={cardIndex} 
                                                    ref={el => cardRefs.current[cardIndex] = el}
                                                    className="p-3 border rounded mb-3 position-relative"
                                                >
                                                    {/* Card Delete Icon (show only if more than 1 card) */}
                                                    {(formData.cards.length > 1) && (
                                                        <div className="position-absolute" style={{ top: '10px', right: '10px', zIndex: 10 }}>
                                                            <FontAwesomeIcon 
                                                                icon={faXmark} 
                                                                className="cursor-pointer text-secondary"
                                                                onClick={() => handleRemoveCard(cardIndex)}
                                                            />
                                                        </div>
                                                    )}

                                                    <Label className='group-header-lbl fw-bold mb-2' htmlFor={`card_header_${cardIndex}`} id={`lbl_card_header_${cardIndex}`} name={`lbl_card_header_${cardIndex}`}>Media Header {formData.cards.length > 1 ? `(${cardIndex + 1})` : ''}</Label>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col md={12} className="mb-2">
                                                                <Label className="automation-lbl" htmlFor={`card_format_${cardIndex}`} id={`lbl_card_format_${cardIndex}`} name={`lbl_card_format_${cardIndex}`}>Format</Label>
                                                                <Select
                                                                    inputId={`card_format_${cardIndex}`}
                                                                    name={`card_format_${cardIndex}`}
                                                                    options={[{label: 'Image', value: 'IMAGE'}, {label: 'Video', value: 'VIDEO'}]}
                                                                    placeholder="Select Format"
                                                                    classNamePrefix="le-select"
                                                                    value={card.mediaHeaderFormat ? {label: card.mediaHeaderFormat === 'IMAGE' ? 'Image' : 'Video', value: card.mediaHeaderFormat} : null}
                                                                    onChange={(e) => handleCardChange(cardIndex, "mediaHeaderFormat", e.value)}
                                                                />
                                                            </Col>
                                                            {card.mediaHeaderFormat && (
                                                                <Col md={12}>
                                                                    <Label className="automation-lbl form-label" htmlFor={`card_upload_${cardIndex}`} id={`lbl_card_upload_${cardIndex}`} name={`lbl_card_upload_${cardIndex}`}>Upload {card.mediaHeaderFormat === 'IMAGE' ? 'Image' : 'Video'}</Label>
                                                                    <CratioFileUploader 
                                                                        mediaUrl={card.mediaUrl || ""}
                                                                        errors={{}} 
                                                                        btnLbl={card.mediaHeaderFormat === 'IMAGE' ? "Choose JPG or PNG File" : "Choose Video File"}
                                                                        handleFile={(e) => onCardFileUpload(e, cardIndex)}
                                                                        filesAccept={card.mediaHeaderFormat === 'IMAGE' ? ".jpg,.png,.jpeg" : ".mp4,.3gp,.mov,.avi"}
                                                                        isLoading={uploadingCardIndices.includes(cardIndex)}
                                                                        isError={invalidCardIndices.includes(cardIndex)}
                                                                        hideFileName={!card.mediaUrl}
                                                                    />
                                                                    {invalidCardIndices.includes(cardIndex) && (
                                                                        <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                                                                            {card.is_original_handle ? `Meta requires media re-upload when editing Carousel Cards.` : "Media is required"}
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </FormGroup>

                                                    <FormGroup className="mt-2">
                                                        <Label className="group-header-lbl fw-bold mb-2" htmlFor={`card_body_${cardIndex}`}>Body <span className="text-muted fw-light"> • Optional</span></Label>
                                                        <Input
                                                            type="text"
                                                            id={`card_body_${cardIndex}`}
                                                            name={`card_body_${cardIndex}`}
                                                            placeholder="Enter text..."
                                                            maxLength={160}
                                                            value={card.body || ''}
                                                            onChange={(e) => handleCardChange(cardIndex, "body", e.target.value)}
                                                        />
                                                    </FormGroup>

                                                    {/* Buttons Section */}
                                                    <div className="mt-3">
                                                        {(card.buttons || []).map((btn, btnIndex) => (
                                                            <div 
                                                                key={btnIndex} 
                                                                className="d-flex align-items-start p-2 mb-2 bg-white border rounded"
                                                                style={{ gap: '10px' }}
                                                            >
                                                                <div className="flex-grow-1">
                                                                    <Row>
                                                                         <Col md={12} className="mb-2">
                                                                            <Label className="automation-lbl text-muted mb-1" style={{fontSize: '12px'}}>
                                                                                {btn.type === 'quick_reply' ? 'Quick Reply' : (btn.type === 'phone_number' ? 'Phone Number' : 'Website URL')}
                                                                            </Label>
                                                                         </Col>
                                                                        <Col md={12} className="mb-2">
                                                                            <Label className="automation-lbl" htmlFor={`btn_text_${cardIndex}_${btnIndex}`} id={`lbl_btn_text_${cardIndex}_${btnIndex}`} name={`lbl_btn_text_${cardIndex}_${btnIndex}`}>Button Text</Label>
                                                                            <div style={{ position: 'relative' }}>
                                                                                <Controller
                                                                                    name={`cards[${cardIndex}].buttons[${btnIndex}].text`}
                                                                                    control={control}
                                                                                    rules={{ required: "Button text is required" }}
                                                                                    defaultValue={btn.text || ''}
                                                                                    render={({ field: { ref, ...field } }) => (
                                                                                        <Input
                                                                                            {...field}
                                                                                            innerRef={ref}
                                                                                            type="text"
                                                                                            id={`btn_text_${cardIndex}_${btnIndex}`}
                                                                                            placeholder="Enter button text"
                                                                                            maxLength={25}
                                                                                            invalid={!!errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.text || !!buttonErrors[`${cardIndex}_${btnIndex}_text`]}
                                                                                            onChange={(e) => {
                                                                                                field.onChange(e);
                                                                                                handleButtonChange(cardIndex, btnIndex, 'text', e.target.value);
                                                                                            }}
                                                                                            style={{ paddingRight: '50px' }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                                {
                                                                                    !errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.text && !buttonErrors[`${cardIndex}_${btnIndex}_text`] && (
                                                                                        <span className="text-secondary" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', pointerEvents: 'none' }}>
                                                                                            {(btn.text || '').length}/25
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                            {(errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.text || buttonErrors[`${cardIndex}_${btnIndex}_text`]) && 
                                                                                <span className="text-danger note-text">{errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.text?.message || buttonErrors[`${cardIndex}_${btnIndex}_text`]}</span>
                                                                            }
                                                                        </Col>
                                                                        {btn.type === 'url' && (
                                                                            <Col md={12} className="mb-0">
                                                                                <Label className="automation-lbl" htmlFor={`btn_value_${cardIndex}_${btnIndex}`} id={`lbl_btn_value_url_${cardIndex}_${btnIndex}`} name={`lbl_btn_value_url_${cardIndex}_${btnIndex}`}>Website URL</Label>
                                                                                <div style={{ position: 'relative' }}>
                                                                                    <Controller
                                                                                        name={`cards[${cardIndex}].buttons[${btnIndex}].value`}
                                                                                        control={control}
                                                                                        rules={{ required: "Website URL is required" }}
                                                                                        defaultValue={btn.value || ''}
                                                                                        render={({ field: { ref, ...field } }) => (
                                                                                            <Input
                                                                                                {...field}
                                                                                                innerRef={ref}
                                                                                                type="text"
                                                                                                id={`btn_value_${cardIndex}_${btnIndex}`}
                                                                                                placeholder="https://example.com"
                                                                                                maxLength={2000}
                                                                                                invalid={!!errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value || !!buttonErrors[`${cardIndex}_${btnIndex}_value`]}
                                                                                                onChange={(e) => {
                                                                                                    field.onChange(e);
                                                                                                    handleButtonChange(cardIndex, btnIndex, 'value', e.target.value);
                                                                                                }}
                                                                                                style={{ paddingRight: '80px' }}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                    <span className="text-secondary" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', pointerEvents: 'none' }}>
                                                                                        {(btn.value || '').length}/2000
                                                                                    </span>
                                                                                </div>
                                                                                {(errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value || buttonErrors[`${cardIndex}_${btnIndex}_value`]) && 
                                                                                    <span className="text-danger note-text">{errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value?.message || buttonErrors[`${cardIndex}_${btnIndex}_value`]}</span>
                                                                                }
                                                                            </Col>
                                                                        )}
                                                                        {btn.type === 'phone_number' && (
                                                                            <Col md={12} className="mb-0">
                                                                                <Label className="automation-lbl" htmlFor={`btn_value_${cardIndex}_${btnIndex}`} id={`lbl_btn_value_phone_${cardIndex}_${btnIndex}`} name={`lbl_btn_value_phone_${cardIndex}_${btnIndex}`}>Phone Number</Label>
                                                                                <div style={{ position: 'relative' }}>
                                                                                    <Controller
                                                                                        name={`cards[${cardIndex}].buttons[${btnIndex}].value`}
                                                                                        control={control}
                                                                                        rules={{ required: "Phone number is required" }}
                                                                                        defaultValue={btn.value || ''}
                                                                                        render={({ field: { ref, ...field } }) => (
                                                                                            <Input
                                                                                                {...field}
                                                                                                innerRef={ref}
                                                                                                type="text"
                                                                                                id={`btn_value_${cardIndex}_${btnIndex}`}
                                                                                                placeholder="+1234567890"
                                                                                                maxLength={20}
                                                                                                invalid={!!errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value || !!buttonErrors[`${cardIndex}_${btnIndex}_value`]}
                                                                                                onChange={(e) => {
                                                                                                    field.onChange(e);
                                                                                                    handleButtonChange(cardIndex, btnIndex, 'value', e.target.value);
                                                                                                }}
                                                                                                style={{ paddingRight: '50px' }}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                    <span className="text-secondary" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', pointerEvents: 'none' }}>
                                                                                        {(btn.value || '').length}/20
                                                                                    </span>
                                                                                </div>
                                                                                {(errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value || buttonErrors[`${cardIndex}_${btnIndex}_value`]) && 
                                                                                    <span className="text-danger note-text">{errors.cards?.[cardIndex]?.buttons?.[btnIndex]?.value?.message || buttonErrors[`${cardIndex}_${btnIndex}_value`]}</span>
                                                                                }
                                                                            </Col>
                                                                        )}
                                                                    </Row>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}

                                            {formData.cards.length < 10 && (
                                                <div className="text-center mt-3">
                                                    <div 
                                                        className="d-inline-flex align-items-center justify-content-center border rounded-circle cursor-pointer" 
                                                        style={{ width: '40px', height: '40px', backgroundColor: '#e9ecef' }}
                                                        onClick={handleAddCard}
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} className="text-secondary" />
                                                    </div>
                                                    <div className="mt-1 small text-secondary">Add Card</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                        
                        {/* Preview Section */}
                        <Col md={5} className="h-100 wa-preview-col-wrapper">
                            <div className={`preview-section ${apiError ? 'preview-section-error' : ''}`}>
                                <div className="preview-header">
                                    <h5>Your template</h5>
                                </div>
                                <div className="preview-body">
                                    <CarouselTemplatePreview 
                                        formData={formData}
                                        components={[
                                            {
                                                type: 'BODY',
                                                text: formData.message || 'Your message here'
                                            },
                                            {
                                                type: 'CAROUSEL',
                                                cards: formData.cards || []
                                            }
                                        ]}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="white" onClick={toggleCarouselModal}>Cancel</Button>
                    <Button className='lePrimaryBtn' disabled={isCreating || !!(template && template.Name)} onClick={handleSubmit(onSubmit)}>
                        {isCreating ? <><Spinner size="sm" className="me-1" /> Creating...</> : "Create"}
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default CarouselModal;
